export default __webpack_public_path__ + "static/media/mc1.123e3fc7.png";